import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import courseService from 'ApiService/Admin/courseService';

const CourseInfo = ({ handleChange, formData, setDisable }) => {
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const res = await courseService.getAllDepartments();
        if (res.data.success) {
          setDepartments(res.data.data || []);
        }
      } catch {
        toast.error('Failed to load departments');
      }
    };
    fetchDepartments();
  }, []);

  useEffect(() => {
    if (formData.courseName && formData.department && formData.duration) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [formData, setDisable]);

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      {/* Title */}
      <h2 className="text-xl font-semibold text-gray-800">Create New Course</h2>

      {/* Grid Layout */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {/* Course Name */}
        <div>
          <label className="mb-2 block text-sm font-medium text-gray-700">
            Course Name
          </label>
          <input
            type="text"
            name="courseName"
            value={formData.courseName}
            onChange={handleChange}
            placeholder="Enter course name"
            className="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm focus:border-brand-500 focus:outline-none"
          />
        </div>

        {/* Department */}
        <div>
          <label className="mb-2 block text-sm font-medium text-gray-700">
            Department
          </label>
          <select
            name="department"
            value={formData.department}
            onChange={handleChange}
            className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm focus:border-brand-500 focus:outline-none"
          >
            <option value="">Click here to Select</option>
            {departments.map((dept) => (
              <option key={dept._id} value={dept._id}>
                {dept.name}
              </option>
            ))}
          </select>
        </div>

        {/* Duration */}
        <div>
          <label className="mb-2 block text-sm font-medium text-gray-700">
            Duration (months)
          </label>
          <input
            type="number"
            name="duration"
            value={formData.duration}
            onChange={handleChange}
            placeholder="Enter duration"
            className="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm focus:border-brand-500 focus:outline-none"
          />
        </div>

        {/* Global Toggle */}
        <div className="flex items-end">
          <div className="flex w-full items-center justify-between rounded-lg border border-gray-300 px-4 py-3">
            <div>
              <p className="text-sm font-medium text-gray-700">Global Course</p>
              <p className="text-xs text-gray-500">
                Available for all branches
              </p>
            </div>

            <input
              type="checkbox"
              name="isGlobal"
              checked={formData.isGlobal}
              onChange={handleChange}
              className="h-5 w-5 accent-brand-500"
            />
          </div>
        </div>
      </div>

      {/* Info */}
      {formData.isGlobal && (
        <p className="w-full py-2 text-center text-sm text-blue-600">
          ℹ️ After selecting global course it will make global branch and it
          will be visible by all branches.
        </p>
      )}
    </div>
  );
};

export default CourseInfo;
